<template>
<div v-show="isModalVisible">
<div class="modal-mask" @click="closeModal">
      <div class="modal-container" @click.stop>
      <!-- Modal Header -->
      <div class="modal-header">
        <h6 class="modal-title">View Repetition</h6>
        <button type="button" class="close" data-dismiss="modal" @click="closeModal">&times;</button>
      </div>
      <!-- Modal body -->
      <div class="modal-body">
        <div class="goal-content">
          <p class="font-weight-bold">Task:</p>
          <p class="task_name">{{ task_name }}</p>
        </div>
        <div class="goal-form">
          <hr class="custom_hr">
          <h6 class="modal-title">My Repetitions</h6>
          <div class="reps_card" v-if="repetitions.length == 0">
              <div class="row">
              <div class="col-12">No reps recorded for this task!</div>
              </div>
          </div>
          <div class="reps_card" v-for="(item, index) in repetitions" :key="index" v-else>
              <div class="row">
              <div class="col-6">Repetition: {{ item.itemCnt }} </div>
              <div class="col-6 text-right">{{ item.createdAt | formatDate }} </div>
              </div>
              <div class="row">
              <div class="col-6">Mentor: {{ item.mentor_name }}</div>
              </div>
              <div class="row">
              <div class="col-6 font-weight-bold">Comment:</div>
              <div class="col-6 text-right font-weight-bold">Time on Task: </div>
              </div>
              <div class="row">
              <div class="col-6">{{ item.comment }}</div>
              <div class="col-6 text-right">{{ item.timeOnTask | formatHourMin }}</div>
              </div>
          </div>
        </div>
      </div>
     </div>
</div>
</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import moment from 'moment';

const today = new Date();
today.setHours(0, 0, 0, 0);

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('MMM DD, YYYY')
  }
});

Vue.filter('formatHourMin', function(value) {
  if (value) {
      let hour = Math.floor(value/60);
      let min = (value%60);
      let timeTask; 

      if (hour > 0) {
        timeTask = hour + ' Hour(s) ' + min + ' Minutes' ;
      }
      else {
        timeTask = min + ' Minutes' ;  
      }
    return timeTask;
  }
});

export default {
  props: [
    'isModalVisible',
    'menteeId',
    'tasklistId',
    'subTaskId',
    'headingId',
    'searchText',
    ],
  data() {
    return {
        taskId: '',
        task_name: '',
        repetitions: [],
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    getScoreLists(item) {
      // console.log(item);
      this.taskId = item.id ? item.id : '';
      this.task_name = item.description ? item.description : '';

      this.fetchRepsHistory();
    },
    fetchRepsHistory() {
        axios.get('/mobile/mentee-repetitions-task', {
          params: {
              mentee_id: this.menteeId,
              task_id: this.taskId,
              tasklist_id: this.tasklistId,
              account_id: this.$store.state.user_accountid,
          }
        })
        .then(response =>  {
            this.repetitions = response.data.repetition;
        })
        .catch(() => {
            console.log("error comes")
        });
    },
  },
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
  overflow-y: scroll;
}
.modal-container {
  position: fixed;
  left: 50%;
  top: 50%;
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 500px;
  height: 500px;
  overflow-y: auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
}
.modal-body {
  margin: 0px;
  padding: 10px;
}
.modal-header .sub-heading {
  background-color: #FFF;
  color: #555;
}
.modal-header {
  padding: 5px;
}
.modal-header .close {
  margin: -1.5rem -2rem -1rem auto;
}
.history-table-wrapper {
  height: 350px;
  overflow-y: auto;
}
.modal-footer {
  border-top: none;
}
.btn-danger {
  background-color: #00ACEE;
  border-color: #00ACEE;
}
.modal-title {
  color: #002F42;
  font-size: 14px;
  font-weight: 900;
}
.goal-content {
  color: #002F42;
  color: #002F42;
  padding: 0;
  margin: 0;
}
.goal-content p { margin-bottom: 0rem; }
.goal-form {
  margin: 20px 0px;
  font-size: 13px;
  color: #002F42;
}
.goal_input {
  border: 2px solid #ddd !important;
  border-radius: 5px !important;
}
.modal-header {
  border-bottom: 0px;
  margin-bottom: 10px;
}
.modal-body {
  padding: 5px;
}
.goal_label {
  font-weight: 900;
  padding: 0.375rem 0.75rem;
}
.goal_label span {
  font-weight: normal;
}
.goal_btn {
  color: #FFF; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-weight: 900;
  width: 150px;
}
.task_name {
  font-size: 14px;
}
.custom_hr {
  border-bottom: 1px solid #00acee;
  margin: 10px 0px;
  width: 100%;
}
.mx-datepicker { width: 236px; }
.form-control { font-size: 14px; }
.hint { float: right; }
.reps_history, .reps_history:active, .reps_history:focus {
  font-size: 16px;
  font-weight: 900;
  color: #002F42 !important;
  text-decoration: none !important;
}
.reps_card {
  background-color: #e8e8e8;
  border-radius: 5px;
  min-height: 40px;
  padding: 10px;
  margin: 10px 0;
}
@media (min-width: 320px) and (max-width: 991px) { 
  .modal-container {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mentee/view_repetition.vue